<template>
  <modal name="disclamer" :scrollable="true" height="auto">

         <div class="modal-content">
           <div class="modal-header">
             <h5 class="modal-title">Disclaimer!!!</h5>
             <button type="button" class="close" @click="$modal.hide('disclamer')">
               <span aria-hidden="true">&times;</span>
             </button>
           </div>
           <div class="modal-body">
             <p>You take all responsibilty for changes done using this feature ....</p>
             <p>This feature working only for first 10 selected shops. Does not matter if you selected in table more than 10 shops.</p>
           </div>
           <div class="modal-footer">
             <button type="button" class="btn btn-primary" @click="$modal.hide('disclamer')">LEAVE</button>
             <button type="button" class="btn btn-secondary" @click="showActionsModal()">(I AM AWARE) CONTINUE</button>
           </div>
         </div>

  </modal>
</template>
<script>
export default {
  name: 'DisclaimerModal',
  data () {
    return {
      time: 0,
      duration: 5000
    }
  },
  methods: {
    showActionsModal: function(){
      this.$modal.hide('disclamer');
      this.$modal.show('list-actions');
    },
    beforeOpen (event) {
      console.log(event)
      // Set the opening time of the modal
      this.time = Date.now()
    },
    beforeClose (event) {
      console.log(event)
      // If modal was open less then 5000 ms - prevent closing it
      if (this.time + this.duration < Date.now()) {
        event.stop()
      }
    }
  }
}
</script>
